import React from 'react';
import compose from 'lodash/fp/compose';
import {
  withUserPersonalWorkspace,
  withUserOrganisationWorkspace,
  withAccount,
  withMsgInfo,
  withTranslation,
  withUserDefaultSpace,
  withDateFormat,
  withLanguage,
  withUserPreferences,
  withNumberFormat,
  withAuth,
  withSpace,
  withDocument,
  withPersonalInfo,
  withUserLayoutChoice,
} from 'components/hoc';
import withFileSize from 'components/hoc/FileSizeChecker/File';
import ContentTemplate from 'components/common/ContentTemplate';
import { useNavigate } from 'react-router-dom';
import { withPayments } from 'components/hoc/Payment';


const SettingsPaymentTab = (props) => {
  const { tr, getLayoutColumnProps, payments, fd, fn } = props;
  const navigate = useNavigate();

  const frontendTableName = 'user_payment';
  const backendTableName = 'user_payment';

  const { columns, layoutColumns } = getLayoutColumnProps(
    frontendTableName,
    backendTableName,
    [],
  );
  let customColumns = [
    {
      id: '_payment_date',
      label: 'payment date',
      order_no: 0,
      selected: false,
      field: 'payment_date',
    },
    {
      id: '_subscription_start_date',
      label: 'Start Date',
      order_no: 1,
      selected: false,
      field: 'subscription_start_date',
    },
    {
      id: '_subscription_end_date',
      label: 'End Date',
      order_no: 2,
      selected: false,
      field: 'subscription_end_date',
    },
    {
      id: '_amount',
      label: 'Amount',
      order_no: 3,
      selected: false,
      field: 'amount',
    },
    {
      id: '_payment_reference',
      label: 'Paypal Reference',
      order_no: 4,
      selected: false,
      field: 'payment_reference',
    },
    {
      id: '_status',
      label: 'Payment Status',
      order_no: 5,
      selected: false,
      field: 'payment_status',
    },
  ];

  return (
    <>
      <>
        <ContentTemplate
          tableName="user_payment"
          columns={customColumns}
          title={tr('Payments')}
          data={payments.map((payment) => {
            let payment_date = fd(payment.payment_date);
            let subscription_start_date = fd(payment.subscription_start_date);
            let subscription_end_date = fd(payment.subscription_end_date);

            return {
              _payment_date: payment_date,
              _subscription_start_date: subscription_start_date,
              _subscription_end_date: subscription_end_date,
              _amount: fn(payment.amount),
              _payment_reference: payment.payment_reference,
              _status: tr(payment.payment_status),
            };
          })}
          showActionButton={true}
          onActionClick={() => {
            navigate('/dashboard/settings/payments/create');
          }}
          isActionButtonDisabled={true}
        />
      </>
    </>
  );
};

export default compose(
  withTranslation,
  withDateFormat,
  withNumberFormat,
  withLanguage,
  withUserPreferences,
  withUserPersonalWorkspace,
  withUserOrganisationWorkspace,
  withUserLayoutChoice,
  withAccount,
  withMsgInfo,
  withUserDefaultSpace,
  withAuth,
  withSpace,
  withDocument,
  withPersonalInfo,
  withFileSize,
  withPayments,
)(SettingsPaymentTab);
